import React from 'react';
import { useAuth } from '../context/AuthContext';

const LockOverlay = () => {
  const { isSystemLocked, canOperate } = useAuth();

  if (!isSystemLocked || canOperate) return null;

  return (
    <div className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-gray-900/95 backdrop-blur-md animate-fade-in">
      <div className="w-20 h-20 rounded-2xl bg-red-500/20 flex items-center justify-center mb-5">
        <svg className="w-10 h-10 text-red-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
        </svg>
      </div>
      <h2 className="text-xl font-bold text-white mb-2">Sistem Kilitli</h2>
      <p className="text-sm text-white/70 text-center max-w-xs mb-1">İşlemler geçici olarak durduruldu.</p>
      <p className="text-sm text-white/70 text-center max-w-xs">Lütfen yönetici ile görüşün.</p>
    </div>
  );
};

export default LockOverlay;
